<template>
  <div>
    <div v-loading="loading" v-if="conversation != null">
      <div class="messages-headline">
        <div v-if="conversation.new_message !== 1">
          <h4 v-if="conversation.is_group == 0" >{{
              conversation.conversation_users[0].user_id == auth.id ? conversation.conversation_users[1].user.name
                  : conversation.conversation_users[0].user.name
            }}</h4>
          <h4 v-else>{{conversation.title}}</h4>
        </div>

        <h4 v-else>{{conversation.name}}</h4>
      </div>
      <!-- Message Content Inner -->
      <div class="message-content-inner" style="height: 494px;" id="container">
        <infinite-loading v-if="conversations !== '' || conversations !== null" spinner="circles" direction="top"
                          @infinite="loadMore"></infinite-loading>
        <div>
          <div
              v-for="item in conversations" :key="item.id"
              class="message-bubble" :class="item.sender_id == auth.id ? 'me' : ''">

            <div class="message-bubble-inner">
              <div class="message-avatar"><img
                  style="object-fit: contain"
                  :src="item.sender.avatar"
                  alt="">
              </div>
              <div class="message-text" :style="item.send == false ? 'background-color:#0073b596' : ''">

                <span v-if=" conversation.is_group == 1 && item.sender_id !== auth.id" style="font-size: 10px;font-weight: bold;color: rgb(0, 115, 181);">{{ item.sender.name }}</span>
                <p>
                  {{ item.message }} <br/> <small style="font-size: 14px;float: right;"
                                                  v-if="item.send == false"><i
                    class="ni ni-time-alarm"></i></small> <small
                    style="font-size: 10px" v-else> {{ item.left_time }}</small>
                </p>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
      <!-- Message Content Inner / End -->
      <!-- Reply Area -->
      <div class="message-reply">
            <textarea cols="1" rows="1" class="form-control" v-model="messageText" :maxlength="charLimit"
                      placeholder="Mesajını yazmak için dokun"
                      @keydown="messageTextCheck"></textarea>
        <div v-if="this.messageText != '' ">
          <button class="btn ripple-effect" v-on:click="sendMessage" v-if="this.sendMessageLoading == false">
            Gönder
          </button>
        </div>
      </div>
    </div>
    <!-- velse -->
    <div style="height: 100%" v-else>
      <div class="messages-headline">
        <h4>Chat Sayfası</h4>
        <!--                                <a href="#" class="message-action"><i class="icon-feather-trash-2"></i> Delete Conversation</a>-->
      </div>
      <!-- Message Content Inner -->
      <div class="message-content-inner" style="height: 100%" v-if="this.conversations.length == 0">
        <div class="empty-body">
          <p style="text-align:center"><i style="font-size: 66px;"
                                          class="icon-feather-message-circle"></i></p>
          <h3 style="text-align:center;margin-bottom: 15px;color: #888888;">Yeni Sohbet Oluşturmak İçin
            Tıklayınız</h3>
          <div style="text-align:center;">
            <button class="empty-button" v-on:click="addNewMessageField">Yeni Mesaj Oluştur</button>
          </div>
        </div>
      </div>
      <!-- Message Content Inner / End -->
    </div>
  </div>
</template>

<script>
import * as axios from "axios";
import Vue from 'vue'
import {getMessagesCount} from "../../services/user-service"

import InfiniteLoading from 'vue-infinite-loading';

Vue.use(InfiniteLoading, {
  slots: {
    noMore: '', // you can pass a string value,
    noResults: '',
  },
});


export default {
  name: "ChatDetail",
  props: ['conversation', 'auth', 'type'],
  data() {
    return {
      data: [],
      busy: false,
      loading: true,
      conversations: [],
      messageText: '',
      sendMessageLoading: false,
      currentPage: 2,
      charLimit: 5000,
      echo: null,
      chatInterval: null
    };
  },
  mounted() {
    this.bindChannels();
  },
  beforeDestroy() {    // channeldan çıkma işlemi yapıldı
    this.leaveChannels();
  },
  created() {
    this.loading = true;
    this.getConversation();
  },
  methods: {
    scrollToBottom() {   // mesaj alanını en alta çekme işlemi
      var container = this.$el.querySelector("#container");
      container.scrollTop = container.scrollHeight;
    },
    bindChannels(){
      this.chatInterval = setInterval(this.getConversation, 60*1000);
      // window.Echo.private('App.User.' + this.getUserModel.id).listen('ConversationEvent', () => {
      //   getMessagesCount();
      // });
    },
    leaveChannels() {
      clearInterval(this.chatInterval);
      // window.Echo.leave('App.User.' + this.getUserModel.id);
    },
    async getConversation() {
      if (this.conversation) {
        // buradaki type parenttan geliyor yeni mesaj ise user olarak backendden veri çekimi var değil ise conversation olarak
        await axios.get("conversations/" + this.conversation.id + "/messages-by-" + this.type).then(response => {
          this.conversations = response.data.data.reverse();
          this.loading = false;
          this.$emit('handleMessageActivity');
          getMessagesCount();
          this.currentPage = 2;
          setTimeout(() => {
            this.scrollToBottom();
          }, 0);
        });
      } else {
        this.loading = false;
      }
    },
    sendMessage() {
      /* Mesajı göndermeden önce conversationa gönderiyoruz ekranda hemen gözükmesi için */
      const messageData = {
        sender_id: this.auth.id,
        message: this.messageText,
        left_time: '',
        conversation:{
          is_group:false
        },
        sender: {
          avatar: this.auth.avatar,
        },
        send: false,
      }
      this.conversations.push(messageData);
      setTimeout(() => {
        this.scrollToBottom();
      }, 0);
      var last_inserted_message = this.conversations[this.conversations.length - 1];
      /* Mesaj push işlemi bitti */
      if (this.type == "conversation") {  // eğer tipi conversation ise conversation id gönder
        const data = {
          message: this.messageText,
          conversation_id: this.conversation.id,
        };
        this.messageText = '';
        axios.post('conversations/messages', data)
            // eslint-disable-next-line no-unused-vars
            .then(response => {
              var date = new Date();
              var hours = date.getHours();
              var minutes = date.getMinutes();
              last_inserted_message.send = true;
              last_inserted_message.left_time = new Date().toLocaleDateString() + " " + hours + ":" + minutes
              this.$emit('handleMessageActivity');
            })
            // eslint-disable-next-line no-unused-vars
            .catch(error => {
            })
      } else {   // eğer tipi conversation değil ise backend tarafına conversation user id değerini gönder
        const data = {
          message: this.messageText,
          new_conversation_user_id: this.conversation.id,
        };
        this.messageText = '';
        axios.post('conversations/messages', data)
            // eslint-disable-next-line no-unused-vars
            .then(response => {
              var date = new Date();
              var hours = date.getHours();
              var minutes = date.getMinutes();
              last_inserted_message.send = true;
              last_inserted_message.left_time = new Date().toLocaleDateString() + " " + hours + ":" + minutes
              this.$emit('handleMessageActivity');
            })
            // eslint-disable-next-line no-unused-vars
            .catch(error => {
              //error
            })

      }
      setTimeout(() => {
        this.scrollToBottom();
      }, 0);
    },
    messageTextCheck(e) {  // keyboard event kontrolleri
      if (e.which === 32 && e.target.selectionStart === 0) {  // inputa ilk başta space ile girmesini engeller
        e.preventDefault();
      } else if (e.which === 13 && e.target.selectionStart === 0) {  //  iinputa ilk başta enter ile girmesini engeller
        e.preventDefault();
      } else if (e.which === 13 && e.target.selectionStart !== 0) { // entera basıldığında mesajın gönderilmesini sağlar
        this.sendMessage();
        e.preventDefault();
      }

    },
    loadMore: function ($state) {  // mesaj alanı yukarı gittikçe daha fazla yükleme alanı
      setTimeout(() => {
        console.log(this.currentPage)
        axios.get("conversations/" + this.conversation.id + "/messages-by-" + this.type + "?page=" + this.currentPage)
            .then(response => {
              // console.log("response data",response.data);
              if (response.data.data.length > 0) {
                this.conversations.unshift(...response.data.data.reverse());
                this.loading = false;
                $state.loaded();
                this.currentPage++;
              } else {
                $state.complete();
              }
            });
      }, 1000)
    },
    addNewMessageField() {  // parenttaki new message alanını true yapmasını tetikler
      this.$emit('openNewMessageField');
    },
  }
}
</script>

<style>
.message-text {
  min-width: 118px;
  max-width: calc(80% - 70px);
}

.message-text p {
  line-break: anywhere;
  overflow: auto;
}

.empty-button {
  margin: auto;
  border: 1px solid #0073b5;
  padding: 10px;
  border-radius: 4px;
  color: white;
  background-color: #0073b5;
}

.empty-body {
  height: 75%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>